/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Link_Invalid_TitleInputs */

const en_login_link_invalid_title = /** @type {(inputs: Login_Link_Invalid_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link not valid`)
};

const de_login_link_invalid_title = /** @type {(inputs: Login_Link_Invalid_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link ungültig`)
};

/**
* | output |
* | --- |
* | "Link not valid" |
*
* @param {Login_Link_Invalid_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const login_link_invalid_title = /** @type {((inputs?: Login_Link_Invalid_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Link_Invalid_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_login_link_invalid_title(inputs)
	return en_login_link_invalid_title(inputs)
});